import { Pencil, Trash2, Navigation2 } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { toast } from 'react-toastify';
import { useStore } from '../../../../hooks/useStore';
import type { IAppointment } from '../../../../models/appointment/AppointmentModel';
import styles from '../Appointments.module.css';

export type AppointmentsActionCellProps = {
  row: IAppointment;
};

const AppointmentsActionCell = ({ row }: AppointmentsActionCellProps) => {
  const { popupStore, appointmentStore, authStore } = useStore();
  const isAdmin = authStore.isAdmin;
  const hasLocation = Boolean(row.hospitalLocation?.trim());

  const handleEdit = async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!row.id) {
      return;
    }

    const fullAppointment = await appointmentStore.fetchAppointmentById(row.id);
    appointmentStore.setSelectedAppointmentToEdit(fullAppointment ?? row);
    popupStore.setIsEditAppointmentOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isAdmin) {
      toast.error('Bu işlem için admin yetkisi gereklidir.');
      return;
    }
    if (row.id) {
      appointmentStore.setAppointmentToDelete(row);
      popupStore.setIsDeleteAppointmentConfirmationOpen(true);
    }
  };

  const handleOpenGoogleMaps = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (row.hospitalLocation) {
      const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(row.hospitalLocation)}`;
      window.open(googleMapsUrl, '_blank');
    }
  };

  return (
    <div className={styles.actionCell}>
      {hasLocation ? (
        <button onClick={handleOpenGoogleMaps} className={styles.mapButton} title="Konuma Git">
          <Navigation2 size={16} strokeWidth={2} />
        </button>
      ) : null}
      <button onClick={e => void handleEdit(e)} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button
        onClick={handleDelete}
        className={`${styles.deleteButton} ${!isAdmin ? styles.disabledButton : ''}`}
        title={isAdmin ? 'Sil' : 'Bu işlem için admin yetkisi gereklidir'}
        disabled={!isAdmin}
      >
        <Trash2 size={16} strokeWidth={2} />
      </button>
    </div>
  );
};

export default observer(AppointmentsActionCell);
